import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import storage from "redux-persist/lib/storage";
// import sessionStorage from "redux-persist/es/storage/session";
import { flashMessage as flash } from "../../../utils/flash";
import { clearStorage, setSessionToken } from "../../../utils/helpers/storage";
import authService from "./authService";


// Get user from LocalStorage
// const user = JSON.parse(localStorage.getItem('user'))

// Initialize state
const initialState = {
  // user: user ? user : null,
  user: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
  tenant: null,
  tenantLoading: false,
  tenantError: false,
  changePassword: false,
  resetSuccess: false,
};

// Authenticate user
export const login = createAsyncThunk("auth/login", async (user, thunkAPI) => {
  try {
    return await authService.login(user);
  } catch (error) {
    const message = error.response.data.error;
    // const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() || error.response.data.error.toString()
    return thunkAPI.rejectWithValue(message);
  }
});

export const getTenantDetails = createAsyncThunk("getDetails", async (user, thunkAPI) => {
  try {
    return await authService.getDetails();
  } catch (error) {
    const message = error.response.data.error;
    // const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() || error.response.data.error.toString()
    return thunkAPI.rejectWithValue(message);
  }
});

export const resetPassword = createAsyncThunk("resetPassword", async (data, thunkAPI) => {
  try {
    return await authService.resetPassword(data);
  } catch (error) {
    const message = error.response.data.error;
    // const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString() || error.response.data.error.toString()
    return thunkAPI.rejectWithValue(message);
  }
});

// Logout user
export const logout = createAsyncThunk("/auth/logout", async () => {
  // let user = {
  //   id: userID,
  // };
  await authService.logout();
});

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    reset(state) {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = false;
      state.changePassword = false;
      state.message = "";
      state.resetSuccess = false;
    },
    resetState: (state) => {
      state = undefined;
    },
    resetAuth: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        if (action.payload.errors) {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload.errors.staff_id[0];
          return;
        }
        state.isLoading = false;
        if (action.payload.UpdatePassword) {          
          state.user = null;
          state.changePassword = action.payload.UpdatePassword;
        } else {
          state.user = action.payload;
        }
        state.isSuccess = true;              
        clearStorage();
        setSessionToken("accessToken", action.payload.token);
        flash("success", action.payload.message);
      })
      .addCase(login.rejected, (state, action) => {    
        
        state.isLoading = false;
        state.isError = true;
        // state.message = action.payload.includes('401') ?
        // 'Invalid Staff ID or Password' : action.payload
        // state.user = null
        flash("error", action.payload);
      })
      .addCase(logout.pending, () => {
        flash("info", "Logging out...");
      })
      .addCase(logout.fulfilled, (state, action) => {
        state.user = null;
        flash("warn", "Logout Successfully");
      })
      .addCase(getTenantDetails.pending, (state) => {
        state.tenantLoading = true;
      })
      .addCase(getTenantDetails.fulfilled, (state, action) => {
        state.tenantLoading = false;
        state.tenantError = false;
        state.tenant = action.payload;     
      })
      .addCase(getTenantDetails.rejected, (state, action) => {
        state.tenantError = true;
        state.tenantLoading = false;     
        state.tenant = null;
        state.user = null;
      })
      .addCase(resetPassword.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.resetSuccess = true;
        flash("success", action.payload.message);     
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        flash("error", action.payload);
      });
  },
});

export const { reset, resetState, resetAuth } = authSlice.actions;

export default authSlice.reducer;
